import { gql } from '@apollo/client';

export const CERTIFICATE_FRAGMENT = gql`
    fragment certificateFragment on Certificate {
        _id
        talent {
            _id
            firstName
        }
        issuer {
            _id
            name
            logo
        }
        title
        number
        url
        profession {
            _id
            professionName
        }
        startDate
        endDate
        current
        file {
            _id
            name
            size
            url
            mimetype
        }
    }
`;
export const CERTIFICATE_PUBLIC_FRAGMENT = gql`
    fragment certificateFragment on CertificatePublic {
        _id
        talent {
            _id
            firstName
        }
        issuer {
            _id
            name
            logo
        }
        title
        number
        url
        profession {
            _id
            professionName
        }
        startDate
        endDate
    }
`;

export const ADD_CERTIFICATE_TALENT = gql`
    mutation addCertificateTalent($certificateInput: CertificateInput, $talentId: ID) {
        addCertificateTalent(certificateInput: $certificateInput, talentId: $talentId) {
            ...certificateFragment
        }
    }
    ${CERTIFICATE_FRAGMENT}
`;
export const UPDATE_CERTIFICATE_TALENT = gql`
    mutation updateCertificateTalent($_id: ID!, $certificateInput: CertificateInput, $talentId: ID) {
        updateCertificateTalent(_id: $_id, certificateInput: $certificateInput, talentId: $talentId) {
            ...certificateFragment
        }
    }
    ${CERTIFICATE_FRAGMENT}
`;

export const DELETE_CERTIFICATE_TALENT = gql`
    mutation deleteCertificateTalent($_id: ID!, $talentId: ID) {
        deleteCertificateTalent(_id: $_id, talentId: $talentId) {
            ...certificateFragment
        }
    }
    ${CERTIFICATE_FRAGMENT}
`;
